module.exports = __webpack_public_path__ + "static/antd-popconfirm-7777fba9560a91c16406531a736c616a.png";